/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import {
    GlLoadingIcon,
    GlIcon,
    GlToken,
    GlDropdownDivider,
} from '@gitlab/ui';
import { debounce } from 'lodash';
import AjaxUtils from '../../util/ajax_utils';
import { ApckGlFilteredSearchToken } from '../../components/filtered_search/apck_glfiltered_search_token';
import { ApckGlFilteredSearchSuggestion } from '../../components/filtered_search/apck_glfiltered_search_suggestion';

const DEBOUNCE_DELAY = 1500; // ms

export const OPERATORS = {
    '==': 'eq',
    '=': 'eq',
    '!=': 'ne',
    '>=': 'ge',
    '<=': 'le',
    '>': 'gt',
    '<': 'lt',
    '~=': 'in',
    '||': 'in',
    '!~=': 'not_in',
    '!||': 'in',
    '~': 'like',
    '~~': 'ilike',
    '^=': 'starts_with',
    '!^=': 'not_starts_with',
    '=$': 'ends_with',
    '!=$': 'not_ends_with',
    '∈': 'contains',
    '∉': 'not_contains',
    '∈S': 'contains_cs',
    '∉S': 'not_contains_cs',
};

export const MultiUserToken = {
    props: ['value', 'active', 'config'],
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlLoadingIcon,
        GlIcon,
    },
    inheritAttrs: false,
    data() {
        return {
            users: [],
            selectedIds: this.value.data ? this.value.data.split(',') : [],
            activeUser: null,
            loadingSuggestions: false,
            // whether to filter on the client side (otherwise: depend on backend)
            frontendFilter: this.config?.frontendFilter,
        };
    },
    computed: {
        filteredUsers() {
            if (!this.frontendFilter) return this.users;
            return this.value.data === ''
                ? this.users
                : this.users.filter((user) => user.username.includes(this.value.data));
        },
        selectedUsers() {
            return this.config.multiSelect
                ? this.users.filter((user) => this.selectedIds.includes(user.id.toString()))
                : this.users.filter((user) => user.id === this.activeUser);
        },
    },
    methods: {
        loadView() {
            this.activeUser = this.users.find((u) => u.id === this.value.data);
        },
        complete(...args) {},
        loadSuggestions: debounce(function () {
            this.loadingSuggestions = true;
            const params = this.config.paramGetter ? this.config.paramGetter(this) : {};
            AjaxUtils.ajax_get({
                url: this.config.url,
                query_params: params,
                opts: { ...this.config.requestOptsFunc({}), flash_form_errors: false },
                success: (data) => {
                    if (data) this.users = data.items;
                    this.loadingSuggestions = false;
                },
            });
        }, DEBOUNCE_DELAY),
        handleSelect(id) {
            if (!this.config.multiSelect) {
                return;
            }
            // we want just one author
            const { operator } = this.value;
            if (operator === '=' || operator === '!=') {
                this.selectedIds = [id.toString()];
                return;
            }

            if (this.selectedIds.includes(id.toString())) {
                this.selectedIds = this.selectedIds.filter((user) => user !== id.toString());
            } else {
                this.selectedIds.push(id.toString());
            }
        },
        isLastUser(index) {
            return index === this.selectedUsers.length - 1;
        },
    },
    watch: {
        // eslint-disable-next-line func-names
        'value.data': function () {
            if (this.active) {
                this.loadingSuggestions = true;
                this.loadSuggestions();
            }
        },
        'value.operator': function () {
            const { operator } = this.value;
            if (this.selectedIds.length > 1 && (operator === '=' || operator === '!=')) {
                this.selectedIds = [this.selectedIds[0]];
            }
        },
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.loadingSuggestions = true;
                    this.loadSuggestions();
                }
            },
        },
    },
    mounted() {
        const { length } = this.selectedIds;
        const ids = this.selectedIds;
        if (length > 0) {
            AjaxUtils.ajax_get({
                url: this.config.url,
                query_params: { db_ids: ids },
                traditional: this.config.traditional,
                opts: { ...this.config.requestOptsFunc({}), flash_form_errors: false },
                success: (data) => {
                    if (data) {
                        this.users = data.items;
                    }
                },
                fail: (...args) => {
                    this.users = [];
                },
            });
        }
    },
    template: `
    <gl-filtered-search-token
      v-bind="{ ...this.$props, ...this.$attrs }"
      v-on="$listeners"
      :multi-select-values="selectedIds"
      :showFriendlyText="config?.showFriendlyText ?? false"
      @select="handleSelect"
      @complete="complete"
    >
    <template #view="{ inputValue }">
      <template v-for="(user, index) in selectedUsers">
        {{ user.username }}
        <span v-if="!isLastUser(index)" class="gl-mx-2">,&nbsp;</span>
      </template>
    </template>
    <template #suggestions>
          <gl-loading-icon size="sm" v-if="loadingSuggestions" />
      <gl-filtered-search-suggestion :key="user.id" v-for="user in filteredUsers" :value="user.id">
        <div class="gl-display-flex gl-align-items-center">
          <gl-icon
            v-if="config.multiSelect"
            name="check"
            class="gl-mr-3 gl-text-gray-700"
            :class="{ 'gl-visibility-hidden': !selectedIds.includes(user.id.toString()) }"
          />
          <div>
            <p class="gl-m-0">{{ user.first_name }} {{ user.last_name }}</p>
            <p class="small gl-m-0">{{ user.email }}</p>
          </div>
        </div>
      </gl-filtered-search-suggestion>
    </template>
    </gl-filtered-search-token>
  `,
};

export const MultiInputToken = {
    props: ['value', 'active', 'config'],
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlLoadingIcon,
        GlIcon,
    },
    inheritAttrs: false,
    data() {
        return {
            data: [],
            selectedData: this.value.data ? this.value.data.split(',') : [],
            activeItem: null,
            key: this.config.key ? this.config.key : 'name',
        };
    },
    computed: {
        filteredUsers() {
            return this.data.filter((e) => e[this.key].includes(this.value.data));
        },
        selectedUsers() {
            return this.config.multiSelect
                ? this.data.filter((e) => this.selectedData.includes(e[this.key]))
                : this.data.filter((e) => e[this.key] === this.activeItem);
        },
    },
    methods: {
        loadView() {
            this.activeItem = this.data.find((u) => u[this.key] === this.value.data);
        },
        loadSuggestions() {
            this.loadingSuggestions = true;
            const params = this.config.paramGetter
                ? this.config.paramGetter(this)
                : {};
            AjaxUtils.ajax_get({
                url: this.config.url,
                query_params: params,
                opts: this.config.requestOptsFunc({}),
                success: (data) => {
                    if (data) this.users = data.items;
                    this.loadingSuggestions = false;
                },
            });
        },
        handleSelect(item) {
            if (!this.config.multiSelect) {
                return;
            }

            // we want just one author
            const { operator } = this.value;
            if (operator === '=' || operator === '!=') {
                this.selectedData = [item];
                return;
            }

            if (this.selectedData.includes(item)) {
                this.selectedData = this.selectedData.filter((e) => e !== item);
            } else {
                this.selectedData.push(item);
            }
        },
        isLastUser(index) {
            return index === this.selectedData.length - 1;
        },
    },
    watch: {
    // eslint-disable-next-line func-names
        'value.data': function () {
            if (this.active) {
                this.loadSuggestions();
            }
        },
        'value.operator': function () {
            const { operator } = this.value;
            if (
                this.selectedData.length > 1
        && (operator === '=' || operator === '!=')
            ) {
                this.selectedData = [this.selectedData[0]];
            }
        },
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.loadSuggestions();
                }
            },
        },
    },
    template: `
      <gl-filtered-search-token
        v-bind="{ ...this.$props, ...this.$attrs }"
        :showFriendlyText="config?.showFriendlyText ?? false"
        v-on="$listeners"
        :multi-select-values="selectedData"
        @select="handleSelect"
      >

      <template #suggestions>
        <gl-filtered-search-suggestion :key="item.id" v-for="item in filteredUsers" :value="item[key]">
          <div class="gl-display-flex gl-align-items-center">
            <gl-icon
              v-if="config.multiSelect"
              name="check"
              class="gl-mr-3 gl-text-gray-700"
              :class="{ 'gl-visibility-hidden': !selectedData.includes(item[key]) }"
            />
            <div>
              <p class="gl-m-0">{{ item.title }}</p>
            </div>
          </div>
        </gl-filtered-search-suggestion>
      </template>
      </gl-filtered-search-token>
    `,
};

export const UserToken = {
    name: 'UserToken',
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlLoadingIcon,
    },
    props: ['value', 'active', 'config'],
    inheritAttrs: false,
    data() {
        return {
            loadingView: false,
            loadingSuggestions: false,
            users: [],
            activeUser: null,
        };
    },
    methods: {
        loadView() {
            this.loadingView = true;

            setTimeout(() => {
                this.loadingView = false;
                this.activeUser = null;
            }, 500);
        },
        loadSuggestions() {
            this.loadingSuggestions = true;
            setTimeout(() => {
                this.loadingSuggestions = false;
                this.users = this.fakeUsers;
            }, 500);
        },
    },
    watch: {
    // eslint-disable-next-line func-names
        'value.data': function () {
            if (this.active) {
                this.loadSuggestions();
            }
        },
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.loadSuggestions();
                }
            },
        },
    },
    template: `
      <gl-filtered-search-token
        v-bind="{ ...this.$props, ...this.$attrs }"
        :showFriendlyText="config?.showFriendlyText ?? false"
        v-on="$listeners"
      >
        <template #view="{ inputValue }">
          <gl-loading-icon size="sm" v-if="loadingView" />
          {{ activeUser ? activeUser.name : inputValue }}
        </template>
        <template #suggestions>
          <template v-if="loadingSuggestions">
            <gl-loading-icon />
          </template>
          <template v-else>
          <gl-filtered-search-suggestion :key="user.id" v-for="user in users" :value="user.username">
            <div class="gl-display-flex">
              <div>
                <p class="gl-m-0">{{ user.name }}</p>
                <p class="gl-m-0">({{ user.email }})</p>
              </div>
            </div>
          </gl-filtered-search-suggestion>
          </template>
        </template>
      </gl-filtered-search-token>
    `,
};

export const ImpactToken = {
    name: 'ImpactToken',
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlToken,
        GlLoadingIcon,
        GlDropdownDivider,
    },
    props: ['value', 'active', 'availableTokens', 'choices', 'viewOnly', 'config'],
    inheritAttrs: false,
    data() {
        return {
            loadingView: false,
            loadingSuggestions: false,
            data: this.config.options,
            // activeLabel: null,
        };
    },
    methods: {
        loadView() {
            this.loadingView = true;
            // this.activeLabel = this.data.find((e) => e.value === this.value.data);
            this.loadingView = false;
        },
        loadSuggestions() {},
    },
    computed: {
        activeLabel() {
            return this.data ? this.data.find((e) => e.value === this.value.data) : null;
        },
        filteredData() {
            return this.data.filter((e) => e.title.toLowerCase().includes(this.value.data));
        },
        containerStyle() {
            if (this.activeLabel) {
                // eslint-disable-next-line camelcase
                const { color, text_color } = this.activeLabel;

                // eslint-disable-next-line camelcase
                return { backgroundColor: color, color: text_color };
            }
            return {};
        },
    },

    watch: {
    // eslint-disable-next-line func-names
        'value.data': function () {},
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.loadSuggestions();
                }
            },
        },
    },
    template: `
  <gl-filtered-search-token
  v-bind="{ ...this.$props, ...this.$attrs }"
  :showFriendlyText="true"
  v-on="$listeners"
  >
  <template #view-token="{ inputValue, cssClasses, listeners }">
    <gl-token variant="search-value" :view-only="viewOnly" :class="cssClasses" :style="containerStyle" v-on="listeners">
    {{ activeLabel ? activeLabel.title : inputValue }}
    </gl-token>
  </template>
  <template #suggestions>
    <gl-dropdown-divider v-if="!loadingSuggestions || filteredData.length" />
    <template v-if="loadingSuggestions">
      <gl-loading-icon />
    </template>
    <template v-else>
      <gl-filtered-search-suggestion :key="entry.id" v-for="entry in filteredData" :value="entry.name">
      <div class="d-flex">
        <span :style="{ color: entry.text_color }">{{ entry.title }}</span>
      </div>
      </gl-filtered-search-suggestion>
    </template>
  </template>
  </gl-filtered-search-token>  
    `,
};

export const LabelToken = {
    name: 'LabelToken',
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlLoadingIcon,
        GlToken,
        GlDropdownDivider,
    },
    props: ['id', 'value', 'active', 'viewOnly', 'config'],
    inheritAttrs: false,
    data() {
        return {
            loadingView: false,
            loadingSuggestions: false,
            data: [],
            activeItem: null,
            cacheResults: this.config.cacheResults ?? false,
        };
    },
    computed: {
        currentValue() {
            return this.value.data.toLowerCase();
        },
        containerStyle() {
            if (this.activeItem) {
                // eslint-disable-next-line camelcase
                const { color, text_color } = this.activeItem;

                // eslint-disable-next-line camelcase
                return { backgroundColor: color, color: text_color };
            }
            return {};
        },
        filteredData() {
            if (this.cacheResults) {
                const suggestions = this.data.filter((e) => e[this.config.displayKey]
                    .toString()
                    .toLowerCase()
                    // eslint-disable-next-line no-useless-escape
                    .includes(this.value.data.replace(/\"/g, '')));
                return suggestions;
            } return this.data;
        },
        nullvalue() {
            return this.config.nullValue === undefined ? 'null' : '""';
        }
    },
    methods: {
        loadView() {
            this.loadingView = true;
            const { key } = this.config;
            // eslint-disable-next-line eqeqeq
            this.activeItem = this.data.find((e) => e[key] == this.value.data);
            this.loadingView = false;
        },
        // eslint-disable-next-line func-names
        loadSuggestions: debounce(function () {
            if (this.cacheResults) {
                return;
            }
            this.loadingSuggestions = true;
            const params = this.config.paramGetter
                ? this.config.paramGetter(this)
                : {};
            AjaxUtils.ajax_get({
                url: this.config.url,
                query_params: params,
                opts: this.config.requestOptsFunc({}),
                success: (data) => {
                    const items = data.items.filter((e) => !!e);
                    if (items) {
                        this.data = this.config.processData
                            ? items.map(this.config.processData)
                            : items;
                    }
                    this.loadingSuggestions = false;
                },
            });
        }, DEBOUNCE_DELAY),
    },
    watch: {
    // eslint-disable-next-line func-names
        'value.data': function () {
            if (this.active) {
                this.loadSuggestions();
            }
        },
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.activeItem = this.data.find(
                        // eslint-disable-next-line eqeqeq
                        (e) => e[this.config.key] == this.value.data,
                    );
                    if (this.activeItem) {
                        this.value.data = `"${this.activeItem[this.config.displayKey]}"`;
                    }
                    this.loadSuggestions();
                }
            },
        },
    },
    mounted() {
        let sessionSavedData = window.sessionStorage.getItem(this.config.id);
        if (this.cacheResults && sessionSavedData) {
            try {
                sessionSavedData = JSON.parse(sessionSavedData);
                this.data = sessionSavedData.filter((e) => !!e);
                if (!this.activeItem) {
                    this.loadView();
                }
                return;
            } catch (e) {
                // in case we cannot parse the caced results we can make data empty so
                // the next if case applies and we load the results "normally"
                this.data = [];
            }
        }
        if (this.data.length === 0) {
            this.loadingSuggestions = true;
            const { search, ...params } = this.config.paramGetter
                ? this.config.paramGetter(this, true)
                : {};
            AjaxUtils.ajax_get({
                url: this.config.url,
                query_params: params,
                traditional: this.config.traditional,
                opts: this.config.requestOptsFunc({}),
                success: (_data) => {
                    if (!_data) return;
                    const data = _data.items.filter((e) => !!e);
                    this.data = (
                        this.config.processData ? data.map(this.config.processData) : data
                    ).filter((e) => !!e);
                    if (!this.activeItem) {
                        this.loadView();
                    }
                    window.sessionStorage.setItem(
                        this.config.id,
                        JSON.stringify(this.data),
                    );
                    this.loadingSuggestions = false;
                },
                fail: () => {
                    this.loadingSuggestions = false;
                }
            });
        }
    },
    template: `
      <gl-filtered-search-token
        v-bind="{ ...this.$props, ...this.$attrs }"
        :showFriendlyText="config?.showFriendlyText ?? true"
        v-on="$listeners"
      >
      <template #view-token="{ inputValue, cssClasses, listeners }">
      <gl-token variant="search-value" :view-only="viewOnly" :class="cssClasses" :style="containerStyle" v-on="listeners">
        {{ activeItem ? activeItem[config.displayKey] : inputValue }}
      </gl-token>
    </template>
        <template #suggestions>
  <gl-filtered-search-suggestion
    :value='nullvalue'
    >None</gl-filtered-search-suggestion>
          <gl-dropdown-divider v-if="loadingSuggestions || data.length" />
            <gl-loading-icon v-if="loadingSuggestions"/>
          <template v-else>
          <gl-filtered-search-suggestion :key="label.id" v-for="label in filteredData" :value="label[config.key].toString()">
            <div class="d-flex">
              <span
                :style="{ backgroundColor: label.color, height: '16px', width: '16px' }"
                class="d-inline-block mr-2"
              ></span>
              {{ label[config.displayKey].toString() }}
            </div>
          </gl-filtered-search-suggestion>
          </template>
        </template>
      </gl-filtered-search-token>
    `,
};

export const MultiLabelToken = {
    name: 'MultiLabelToken',
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlLoadingIcon,
        GlToken,
        GlDropdownDivider,
        GlIcon,
    },
    props: ['id', 'value', 'active', 'viewOnly', 'config'],
    inheritAttrs: false,
    data() {
        const selectedData = this.value.data ? this.value.data.split(',') : [];
        return {
            loadingView: false,
            loadingSuggestions: false,
            data: [],
            selectedIds: selectedData,
            selectedData: [],
            selectedSet: new Set(selectedData),
            activeItem: null,
            nullSelected: false,
            loadedData: [],
            emptyItem: {
                [this.config.key]: 'null',
                [this.config.displayKey]: 'None',
            },
        };
    },
    computed: {
        currentValue() {
            return this.value.data.toLowerCase();
        },
        containerStyle() {
            if (this.activeItem) {
                // eslint-disable-next-line camelcase
                const { color, text_color } = this.activeItem;

                // eslint-disable-next-line camelcase
                return { backgroundColor: color, color: text_color };
            }
            return {};
        },
        selected() {
            const { key } = this.config;
            const getItem = (item) => (!item ? this.emptyItem[key] : item[key]);
            return this.selectedData.filter(
                (item) => this.selectedIds.includes(getItem(item).toString()),
            );
        },
        notSelected() {
            const { key } = this.config;
            return this.data.filter(
                (item) => !this.selectedIds.includes(item[key].toString()),
            );
        },
        selectedItems() {
            const { key } = this.config;
            return this.config.multiSelect
                ? this.data.filter((item) => this.selectedIds.includes(item[key]))
                : this.data.filter((item) => item[key] === this.activeItem);
        },
    },
    methods: {
        loadView() {
            this.loadingView = true;
            this.loadingView = false;
        },
        split(...args) {
            if (this.value.data === 'null') {
                this.nullSelected = true;
                this.selectedIds = [null];
                this.selectedData = [this.emptyItem];
            }
        },
        loadSuggestions() {
            const params = this.config.paramGetter
                ? this.config.paramGetter(this)
                : {};
            if (this.config.defaultOptions && !params.search?.length) {
                const data = this.config.defaultOptions;
                if (data) this.data = data;
                this.loadingSuggestions = false;
                return
            }

            AjaxUtils.ajax_get({
                url: this.config.url,
                query_params: params,
                traditional: this.config.traditional,
                opts: this.config.requestOptsFunc({}),
                success: (data) => {
                    if (data) this.data = data.items;
                    if (this.loadedData) {
                        const loadedSet = new Set(
                            this.loadedData.map((e) => e[this.config.key].toString()),
                        );
                        const missing = this.data.filter(
                            (e) => !loadedSet.has(e[this.config.key].toString()),
                        );
                        this.data = missing.concat(this.loadedData);
                    }
                    this.loadingSuggestions = false;
                },
                fail: () => {
                    this.data = [];
                    this.loadingSuggestions = false;
                },
            });
        },
        debouncedLoadSuggestions: debounce(function () {
            this.loadSuggestions();
        }, DEBOUNCE_DELAY),
        handleSelect(item) {
            if (!this.config.multiSelect) {
                return;
            }
            const entry = item.toString();
            const isNone = entry === 'null';
            // we want just one
            const { operator } = this.value;
            const singleSelectOperator = operator === '=' || operator === '!=';
            const _selected = this.selectedIds.includes(entry);
            if (isNone && singleSelectOperator) {
                this.selectedIds = _selected ? [] : [entry];
                this.selectedData = _selected ? [] : [this.emptyItem];
                this.nullSelected = !_selected;
                return;
            } if (singleSelectOperator) {
                this.selectedIds = _selected ? [] : [entry];
                this.selectedData = _selected
                    ? []
                    : [this.data.find((e) => e[this.config.key] === item)];
                this.nullSelected = false;
                return;
            } if (isNone) {
                // selecting/unselecting the null option in the multi-select mode
                this.selectedIds = _selected
                    ? this.selectedIds.filter((e) => e !== 'null')
                    : [entry, ...this.selectedIds];
                this.selectedData = _selected
                    ? this.selectedData.filter((e) => e[this.config.key] !== 'null')
                    : [this.emptyItem, ...this.selectedData];
                this.nullSelected = !_selected;
                return;
            }
            if (this.selectedIds.includes(entry)) {
                this.selectedIds = this.selectedIds.filter((e) => e !== entry);
                this.selectedData = this.selectedData.filter(
                    (e) => e[this.config.key] !== item,
                );
                this.loadedData = this.loadedData.filter(
                    (e) => e[this.config.key] !== item,
                );
            } else {
                this.selectedIds.push(entry);
                this.selectedData.push(
                    this.data.find((e) => e[this.config.key] === item),
                );
            }
        },
        filterSuggestions(arr, include) {
            const set = this.selectedSet;
            const { key } = this.config;
            const res = include
                ? arr.filter((e) => set.has(e[key].toString()))
                : arr.filter((e) => !set.has(e[key].toString()));
            return res;
        },
        isLastItem(index) {
            return index === this.selectedItems.length - 1;
        },
    },
    watch: {
    // eslint-disable-next-line func-names
        'value.data': function () {
            if (this.active) {
                this.loadingSuggestions = true;
                this.debouncedLoadSuggestions();
            }
        },
        'value.operator': function () {
            const { operator } = this.value;
            if (
                this.selectedIds.length > 1
        && (operator === '=' || operator === '!=')
            ) {
                this.selectedIds = [this.selectedIds[0]];
                this.selectedData = [this.selectedData[0]];
            }
        },
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.loadSuggestions();
                }
            },
        },
    },
    mounted() {
        const { length } = this.selectedIds;
        // there is a null picked
        const nullSelected = this.selectedIds.includes('null');
        this.nullSelected = nullSelected;
        const ids = this.selectedIds
            // eslint-disable-next-line no-restricted-globals
            .filter((e) => e !== 'null' && !isNaN(e))
            .map((e) => parseInt(e, 10));
        if (nullSelected && length === 1) {
            const items = [this.emptyItem];
            this.loadedData = [];
            this.selectedData = items;
        } else if (ids.length > 0) {
            const params = this.config.paramGetter
                ? this.config.paramGetter(this, true)
                : {};
            AjaxUtils.ajax_get({
                url: this.config.url,
                query_params: { ...params, db_ids: ids },
                traditional: this.config.traditional,
                opts: this.config.requestOptsFunc({}),
                success: (data) => {
                    if (data) {
                        const items = nullSelected
                            ? [this.emptyItem, ...data.items]
                            : data.items;
                        this.loadedData = data.items;
                        this.selectedData = items;
                    }
                },
                fail: (...args) => {
                    const items = nullSelected ? [this.emptyItem] : [];
                    this.loadedData = items;
                    this.selectedData = items;
                },
            });
        }
    },
    template: `
  <gl-filtered-search-token
  v-bind="{ ...this.$props, ...this.$attrs }"
  :showFriendlyText="config?.showFriendlyText ?? false"
  v-on="$listeners"
  :multi-select-values="selectedIds"
  @select="handleSelect"
  @split="split"
>
<template #view="{ inputValue, cssClasses, listeners }">
  <template v-for="(item, index) in selectedData">
    {{ item[config.displayKey].toString().slice(0, 25) }}
    <span v-if="!isLastItem(index)" class="gl-mx-2">,&nbsp;</span>
  </template>
</template>
<template #suggestions>
<gl-filtered-search-suggestion :key="item[config.key]" v-for="item in selected" :value="item[config.key]">
    <div class="gl-display-flex gl-align-items-center">
      <gl-icon
        v-if="config.multiSelect"
        name="check"
        class="gl-mr-3 gl-text-gray-700 gl-icon s-label"
      />
      <div>
        <p class="gl-m-0">{{ item[config.displayKey] }}</p>
      </div>
    </div>
  </gl-filtered-search-suggestion>
<gl-dropdown-divider v-if="selectedData.length" />
<gl-loading-icon size="sm" v-if="loadingSuggestions" />
  <gl-filtered-search-suggestion v-else :key="item.id" v-for="item in notSelected" :value="item[config.key]">
    <div class="gl-display-flex gl-align-items-center">
      <div>
        <p class="gl-m-0">{{ item[config.displayKey] }}</p>
      </div>
    </div>
  </gl-filtered-search-suggestion>
  <gl-filtered-search-suggestion value="null" v-if="!nullSelected && !config.hideNoneSuggestion">
<div class="gl-display-flex gl-align-items-center">
None
</div>
</gl-filtered-search-suggestion>
</template>
</gl-filtered-search-token>

    `,
};


// eslint-disable-next-line no-unused-vars
export const DateTimeToken = {
    name: 'DateTimeToken',
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlToken,
        GlLoadingIcon,
        GlDropdownDivider,
    },
    props: ['value', 'active', 'availableTokens', 'viewOnly', 'config'],
    inheritAttrs: false,
    data() {
        return {
            loadingView: false,
            loadingSuggestions: false,
            activeDate: null,
            datePicked: null,
            activeLabel: null,
        };
    },
    methods: {
        loadView() {
        if (!this.value.data) {
            const date = new Date();
            date.setHours(0); date.setMinutes(0);
            // Use LOCAL date components for the datetime-local input format.
            // toISOString() gives UTC which shifts by the timezone offset.
            const pad = (n) => String(n).padStart(2, '0');
            const localDateTime = `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
            this.value.data = localDateTime;
            this.value.operator = '=';
        }
        },
        loadSuggestions() {},
    },
    computed: {
        filteredData() {
            return this.data.filter((e) => e.title.toLowerCase().includes(this.value.data));
        },
        containerStyle() {
            if (this.activeLabel) {
                // eslint-disable-next-line camelcase
                const { color, text_color } = this.activeLabel;

                // eslint-disable-next-line camelcase
                return { backgroundColor: color, color: text_color };
            }
            return {};
        },
    },

    watch: {
    // eslint-disable-next-line func-names
        'value.data': function () {},
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.loadSuggestions();
                }
            },
        },
    },
    template: `
  <gl-filtered-search-token
  v-bind="{ ...this.$props, ...this.$attrs }"
  :showFriendlyText="config?.showFriendlyText ?? false"
  v-on="$listeners"
  >
  <template #view-token="{ inputValue, cssClasses, listeners }">

    <gl-token variant="search-value" :view-only="viewOnly" :class="cssClasses" :style="containerStyle" v-on="listeners">
    {{ activeLabel ? activeLabel.title : inputValue }}
    </gl-token>
  </template>
  </gl-filtered-search-token>  
    `,
};

// eslint-disable-next-line no-unused-vars
export const CVEToken = {
    name: 'CVEToken',
    components: {
        'gl-filtered-search-token': ApckGlFilteredSearchToken,
        'gl-filtered-search-suggestion': ApckGlFilteredSearchSuggestion,
        GlToken,
        GlLoadingIcon,
        GlDropdownDivider,
    },
    props: ['value', 'active', 'availableTokens', 'viewOnly', 'config'],
    inheritAttrs: false,
    data() {
        return {
            activeLabel: null,
            loadingView: false,
            loadingSuggestions: false,
        };
    },
    methods: {
        loadView() {},
        loadSuggestions() {},
    },
    computed: {
        filteredData() {
            return this.data.filter((e) => e.title.toLowerCase().includes(this.value.data));
        },
        containerStyle() {
            if (this.activeLabel) {
                // eslint-disable-next-line camelcase
                const { color, text_color } = this.activeLabel;

                // eslint-disable-next-line camelcase
                return { backgroundColor: color, color: text_color };
            }
            return {};
        },
    },
    watch: {
    // eslint-disable-next-line func-names
        'value.data': function () {},
        active: {
            immediate: true,
            handler(newValue) {
                if (!newValue) {
                    this.loadView();
                } else {
                    this.loadSuggestions();
                }
            },
        },
    },
    template: `
  <gl-filtered-search-token
  v-bind="{ ...this.$props, ...this.$attrs }"
  :showFriendlyText="config?.showFriendlyText ?? false"
  placeholder="E.g. CVE-2013-6438, CVE-2016-8740"
  v-on="$listeners"
  >
  <template #view-token="{ inputValue, cssClasses, listeners }">

    <gl-token variant="search-value" :view-only="viewOnly" :class="cssClasses" :style="containerStyle" v-on="listeners">
    {{ activeLabel ? activeLabel.title : inputValue }}
    </gl-token>
  </template>
  </gl-filtered-search-token>
    `,
};
